import React, { useState } from 'react';
import "../../App.scss";
import "./UploadModal.scss";
import { getIcon } from '../../../utils/images';
import { uploadShipmentDocuments } from '../../../services/shipments';
import { message, Modal, Button } from 'antd';
import Dragger from 'antd/es/upload/Dragger';
import { InboxOutlined } from "@ant-design/icons"


const UploadModalTitle = ({ handleCancel }) => {
  return (
    <div className='UploadModal__Title'>
      <img className='close' src={getIcon('close')} onClick={handleCancel} />
      <div className='title'>
        Upload Documents
      </div>
    </div>
  )
};

const UploadModal = ({ shipment, isOpen, handleCancel }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async() => {
    const formData = new FormData();
    fileList.forEach((file) => formData.append('files[]', file));
    setUploading(true);
    try {
      await uploadShipmentDocuments(shipment.id, formData);
      message.success('Upload successfully.');
    } catch(e) {
      message.error('Upload failed.');
    } finally {
      setUploading(false);
      setFileList([])
      handleCancel()
    }
  };

  const props = {
    name: 'file',
    accept: ".doc,.docx,.pdf,.xls,.xlsx,.csv,image/*",
    multiple: true,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  return (
    <Modal
      className='App UploadModal'
      title={<UploadModalTitle handleCancel={handleCancel} />}
      open={isOpen}
      footer={null}
      closable={false}
      destroyOnClose={true}
      forceRender={true}
    >
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
      </Dragger>

      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        className='submit-btn'
      >
        {uploading ? 'Uploading' : 'Start Upload'}
      </Button>
    </Modal>
  );
};

export default UploadModal;
